export default function addedToCart() {
    window.$.subscribe('/product/added-to-cart', function (event, product_unique_id, basket_response) {
        const basket_product = basket_response.products.find(product => product.product.unique_id === product_unique_id);

        if (basket_product !== undefined){

            Riode.Minipopup.open({
                message: translates.product_added_to_cart,
                productClass: 'product-cart',
                name: basket_product.product.name,
                nameLink: basket_product.product.url,
                imageSrc: basket_product.product.image?.url,
                imageLink: basket_product.product.url,
                price: basket_product.total_readable,
                count: null,
                actionTemplate: `<div class="action-group d-flex">
            <a href="/basket" class="btn btn-sm btn-primary btn-rounded">${translates.complete_order}</a>
            </div>`
            })

        }

    });
}
